import {Dispatch, default as React} from 'react';
import {Action} from './base/fsa/createAction';

import intercomIcon from './assets/images/icons/intercom.png';
import scenarioIcon from './assets/images/icons/scenario.png';
import sensorIcon from './assets/images/icons/sensor.png';
import alarmIcon from './assets/images/icons/alarm.png';
import cameraIcon from './assets/images/icons/camera.png';
import {RouteComponentProps} from 'react-router';
import {CameraScreen} from './screens/CameraScreen';
import {AlarmScreen} from './screens/AlarmScreen';
import {IntercomScreen} from './screens/IntercomScreen';
import {MediaCreateScreen} from './screens/MediaCreateScreen';
import {LoginScreen} from './screens/LoginScreen';
import {IntercomModel} from './types/intercom';
import {setIntercomInfoAction, setIntercomStatusAction} from './store/control/actions';
import {SettingsRoutes} from './screens/Settings';
import {MainScreen} from './screens/MainScreen';
import {UserSettingsScreen} from './screens/SettingsScreen/UserSettingsScreen';
import {ScenarioScreen} from './screens/ScenarioScreen';
import {SensorScreen} from './screens/SensorScreen';
import {PageScreen} from './screens/PageScreen';
import {MediaListScreen} from './screens/MediaListScreen';
import {ConciergeScreen} from './screens/ConciergeScreen';
import {MeetingScreen} from "./screens/MeetingScreen";

export type RouteDefinition = {
    routerLink?: string;
    exact?: boolean;
    component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
};

export const getRouteList = (): RouteDefinition[] => [
    {
        routerLink: '/',
        component: MainScreen,
        exact: true,
    },
    {
        routerLink: '/login',
        component: LoginScreen,
        exact: true,
    },
    {
        routerLink: '/intercom',
        component: IntercomScreen,
        exact: true,
    },
    {
        routerLink: '/camera',
        component: CameraScreen,
        exact: true,
    },
    {
        routerLink: '/alarm',
        component: AlarmScreen,
        exact: true,
    },
    {
        routerLink: '/scenario',
        component: ScenarioScreen,
        exact: true,
    },
    {
        routerLink: '/sensor',
        component: SensorScreen,
        exact: true,
    },
    {
        routerLink: '/concierge',
        component: ConciergeScreen,
    },
    {
        routerLink: '/meeting',
        component: MeetingScreen,
    },
    {
        routerLink: '/media-remote/create',
        component: MediaCreateScreen,
    },
    ...SettingsRoutes,
    {
        routerLink: '/settings',
        component: UserSettingsScreen,
    },
    {
        routerLink: '/page/:id',
        component: PageScreen,
    },
    {
        routerLink: '/media-remote',
        component: MediaListScreen,
    },
];
